/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  selector: 'gh-setup-scheduling-schedule-templates-tab',
  template: require('./scheduling-schedule-templates-tab.component.html'),
})
export class SchedulingScheduleTemplatesTabComponent {
}
